import { render, staticRenderFns } from "./accessControlGateList.vue?vue&type=template&id=4b238006&scoped=true"
import script from "./accessControlGateList.vue?vue&type=script&lang=js"
export * from "./accessControlGateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b238006",
  null
  
)

export default component.exports